<template>
  <!-- <v-container> -->
    <v-layout wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-card>
          <v-card-title primary-title>
            <h2>Unsere Stärken sind Ihr Vorteil</h2>
          </v-card-title>
          <v-card-text>
            <v-list three-line>
              <template v-for="(item) in items">
                <v-list-tile :key="item.title" avatar>
                  <v-list-tile-avatar>
                    <v-icon color="green">done_outline</v-icon>
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-html="item.title"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  <!-- </v-container> -->
</template>

<script>
  export default {
    data: () => ({
      items: [
        {
          title: 'Sie brauchen Handwerker?',
          subtitle: 'Bei uns bekommen Sie viele Handwerkerleistungen aus einer Hand.'
        },
        {
          title: 'Sie wollen Qualität zum guten Preis?',
          subtitle: 'Bei uns bekommen Sie ein eingespieltes Team für schnelle und professionelle Arbeit.'
        },
        {
          title: 'Die Arbeit soll schnell erledigt werden?',
          subtitle: 'Bei uns bekommen Sie einen stetigen Arbeitsfortschritt dank direkter Kommunikation / Abstimmung,'
        }
      ]
    })
  }
</script>
